import { makeStyles } from '@material-ui/core'

const useContactInfoStyles = makeStyles((theme) => {
    const mobileBreakpoint = theme.breakpoints.down('sm')
    return {
        contactInfoWrapper: {
            minHeight: 'calc(100vh - 208px)',
            display: 'flex',
            alignItems: 'center',
            marginBottom: 0,
            paddingLeft: '88px',
            paddingRight: '48px',
            [mobileBreakpoint]: {
                paddingLeft: '24px',
                paddingRight: '24px'
            }
        },
        title: {
            fontSize: '24px',
            lineHeight: '34px',
            fontFamily: 'var(--font-family-base)',
            color: 'var(--black)',
            marginBottom: '1rem',
        },
        contentClass: {
            display: 'flex',
            flexDirection: 'column',
            flexBasis: '75%',
            flex: '1',
            width: '100%',
            [mobileBreakpoint]: {
                margin: '0px',
                width: '100%',
            },
        },
        mainBox: {
            height: '100%',
            width: '576px',
        },
        subtitle: {
            fontSize: '24px',
            fontFamily: 'Roboto',
            fontWeight: 500,
            lineHeight: '28px',
            marginBottom: '0.5rem',
        },
        contentGrid: {
            width: '50%',
        },
        contentInfo: {
            fontSize: '14px',
            fontWeight: 400,
            color: '#757575',
            paddingLeft: '20px',
        },
        agreeTerms: {
            '& a': {
                fontSize: '14px',
            },
            fontSize: '14px',
            fontFamily: 'Roboto',
            fontWeight: 400,
            color: '#000000',
            lineHeight: '20px',
            marginTop: '0.375rem',
            marginBottom: '0.9375rem',
        },
        countryCode: {
            '& label': {
                marginTop: '3px',
            },
        },
        workEmail: {
            color: '#9E9E9E',
            marginTop: '0.5rem',
            marginBottom: '0.5rem',
        },
        continueButton: {
            textAlign: 'right',
        },
        customLoadingBox: {
            display: 'flex',
            flexDirection: 'column',
            padding: '16px !important',
        },
        boxContent: {
            padding: '25px !important',
        },

        btn_primary: {
            color: 'var(--white)',
            backgroundColor: 'var(--teal-blue)',
            '&:hover': {
                color: 'var(--white)',
                backgroundColor: 'var(--teal-blue)',
            },
        },

        contentText: {
            fontWeight: 500,
            [mobileBreakpoint]: {
                paddingBottom: '0px !important',
            },
        },
        button: {
            [mobileBreakpoint]: {
                width: '100%',
            },
            '&.Mui-disabled': {
                backgroundColor: 'var(--neutrals-grey-300, #E0E0E0) !important',
                color: 'var(--neutrals-grey-600, #757575) !important',
                boxShadow: 'none',
                borderRadius: '4px',
                textAlign: 'center',
            },
        },
        bannerImgUrlRectangle: {
            [mobileBreakpoint]: {
                backgroundImage: 'none',
            },
        },
        root: {
            [mobileBreakpoint]: {
                backgroundImage: 'none !important'
            },
        },
        modalBox: {
            position: 'absolute' as 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            height: 308,
            width: 536,
            backgroundColor: 'white',
            borderRadius: '4px',
            [mobileBreakpoint]: {
                width: '20em',
                height: 'auto',
                paddingBottom: '10px',
            },
        },
        trapezoidBgContactInfo: {
            position: 'relative',
            zIndex: 1,
            '&::before': {
                content: '""',
                background: 'linear-gradient(234deg, #005C82 28.58%, #0B9EDB 99.46%)',
                position: 'absolute',
                top: '0',
                left: '0',
                width: '100%',
                height: '100%',
                clipPath: 'polygon(95% 0, 100% 0, 100% 100%, 37.5% 100%)'
            }
        }
    }
})
export default useContactInfoStyles
